package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.db.LogfileData
import com.neurobs.js.ccab.CCABServer
import com.neurobs.js.controller.{AdminListAdapter, AdminListController, AdminPanelDelegate}
import com.neurobs.js.util.StringUtilities.dateTimeString
import com.neurobs.js.dom.ElementFactory

import scala.concurrent.{Future, Promise}

class LogfileListController(testRunId: Long) extends AdminListAdapter[LogfileData] {

	override def title = s"Test Run $testRunId Logfiles"

	override def itemName = "Logfile"

	override def columnHeaders = Seq(
		"Created",
		"Start Time",
		"Subject GUID",
		"Package GUID",
		"Expt GUID",
		"Scenario",
		"Orig Filename",
		"Location",
		"Storage Id",
		"Atten",
		""
	)

	override def itemRow(a: LogfileData, delegate: Option[AdminPanelDelegate], controller: AdminListController[LogfileData]) = Seq(
		dateTimeString(a.createdAt),
		dateTimeString(a.startTime),
		a.subjectGuid.noBracketsString,
		a.packageGuid.noBracketsString,
		a.experimentGuid.noBracketsString,
		a.scenario,
		a.origFilename,
		a.location.getOrElse[String](default = ""),
		a.logfileStorageId.map(_.toString).getOrElse[String](default = ""),
		a.audioAttenuation.map(_.toString).getOrElse[String](default = ""),
		a.logfileStorageId match {
			case None => ""
			case Some(id) =>
				val a = ElementFactory.makeLink(text = "view")
				a.href = s"/api/v1/test_runs/$testRunId/logfile"
				a.target = "_blank"
				a
		}
	)

	override val create = None

	override def get(): Future[Either[String, Seq[LogfileData]]] = {
		val promise = Promise[Either[String, Seq[LogfileData]]]
		CCABServer.getLogfiles(testRunId) {
			case Left(error) => promise.success(Left(error.message))
			case Right(list) => promise.success(Right(list))
		}
		promise.future
	}
}

object LogfileListController {
	def apply(testRunId: Long): AdminListController[LogfileData] = new AdminListController[LogfileData](new LogfileListController(testRunId))
}